import { api } from "@/api";

// Returns the user's favorited match (event) ids, e.g. [72338575].
export const getFavoriteMatches = async ({
  signal
}: { signal?: AbortSignal } = {}): Promise<number[]> => {
  const res = await api.client.get(`/favorite-matches`, { signal });
  return res.data;
};
